import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import '../../styles/landingpage.css';
import api from '../../utils/api'; // Make sure this file exists and exports an axios instance

const HomePage = () => {
    const navigate = useNavigate();


    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [currentUser, setCurrentUser] = useState('');



    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector('header');
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const showModal = () => {
        document.getElementById('signinModal').style.display = 'flex';
    };

    const hideModal = () => {
        document.getElementById('signinModal').style.display = 'none';
    };

    const showSignUpModal = () => {
        document.getElementById('signupModal').classList.add('show');
    };

    const hideSignUpModal = () => {
        document.getElementById('signupModal').classList.remove('show');
    };

    const handleSignIn = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/authenticate', {
                username,
                password,
                rememberMe: true,
            });

            const token = response.data?.id_token;
            if (token) {
                sessionStorage.setItem('token', token);
                sessionStorage.setItem('username', username);
                setIsAuthenticated(true);
                setCurrentUser(username);
                hideModal();
                setUsername('');
                setPassword('');
                setError('');
                navigate("/home");
            } else {
                setError('Invalid response from server.');
            }
        } catch (err) {
            setError('Login failed. Please check your credentials.');
        }
    };

    const handleSignUp = (e) => {
        e.preventDefault();
        alert('Sign up submitted!');
        hideSignUpModal();
    };

    const heroStyle = {
        backgroundImage: `url(/images/home.png)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left center',
        backgroundSize: 'cover',
    };

    return (
        <div>
            <header>
                <div className="logo">
                    <img src="/images/logo.png" alt="Sahaj Gyan" />
                </div>
                <div className="menu-toggle" onClick={() => document.getElementById('topNav').classList.toggle('show')}>
                    ☰
                </div>
                <nav id="topNav" className="nav-links">
                    <a href="#home" className="nav-link">Home</a>
                    <a href="#pillars" className="nav-link">Pillars</a>
                </nav>
                <button className="sign-in-btn" onClick={showModal}>Sign In</button>
            </header>

            <section id="home" className="hero" style={heroStyle}>
                <div className="hero-text">
                    <h2>Learning simplified</h2>
                    <p>Sahaj Gyan envisions learning as a living tree — rooted in clarity, growing with curiosity,
                        and bearing the fruits of understanding. We believe that when knowledge is planted in simple soil,
                        it takes root with ease and grows into wisdom that lasts a lifetime.
                    </p>
                    <br />
                    <p>
                        Through thoughtful, visual learning, we aim to nourish minds, spark wonder, and let learning unfold
                        as naturally as leaves to the sun.</p>
                    <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #aaa' }} />
                    <p>
                        {/* <a href="#" onClick={showSignUpModal}>Sign up</a> to create an account or{' '} */}
                        <a href="#" onClick={showModal}>Sign in</a> to access learning content.
                    </p>
                </div>
            </section>

            <section className="pillars" id="pillars">
                <h2 className="pillars-heading">Our Pillars</h2>
                <div className="pillar-container">
                    {/* Tutors */}
                    <div className="pillar red">
                        <img src="/images/tutor.png" alt="Tutor" className="pillar-icon" />
                        <br /><br />
                        <h3>Tutors</h3>
                        <p>
                            With Sahaj Gyan, aspiring tutors can focus on what they do best — teaching with passion and creativity.
                        </p>
                        <p>
                            The platform empowers educators to deliver lessons in a fun, intuitive way using features like{' '}
                            <strong>Interactive Labs</strong> and <strong>Thought-Provoking DIY Experiments</strong> that spark curiosity
                            and deepen understanding.
                        </p>
                        <p>
                            Beyond the classroom, Sahaj Gyan streamlines administrative tasks — from onboarding students and crafting test
                            plans, to conducting assessments, tracking learning progress, and managing earnings — all through a seamless,
                            digitized workflow.
                        </p>
                    </div>

                    {/* Parents */}
                    <div className="pillar teal">
                        <img src="/images/parent.png" alt="Parent" className="pillar-icon" />
                        <br /><br />
                        <h3>Parents</h3>
                        <p>
                            Parents can take an active role in their child’s learning journey by creating custom test plans, administering
                            assessments, and closely tracking progress.
                        </p>
                        <p>
                            With Sahaj Gyan, they gain meaningful insights into their child’s strengths and areas for improvement —
                            helping them support growth with clarity and confidence.
                        </p>
                    </div>

                    {/* Students */}
                    <div className="pillar purple">
                        <img src="/images/student.png" alt="Student" className="pillar-icon" />
                        <br /><br />
                        <h3>Students</h3>
                        <p>
                            Students can take tests assigned by tutors or parents and receive clear, personalized insights into their
                            strengths and areas for improvement.
                        </p>
                        <p>These insights empower them to learn smarter and grow with confidence.</p>
                    </div>
                </div>
            </section>


            <footer>
                © 2025 Sahaj Gyan India Pvt. Ltd. All rights reserved.
            </footer>

            {/* Sign In Modal */}
            <div className="modal" id="signinModal">
                <div className="modal-content">
                    <span className="modal-close" onClick={hideModal}>✖</span>
                    <h3>Sign In</h3>
                    <form id="signinForm" onSubmit={handleSignIn}>
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button type="submit">Sign In</button>
                        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                    </form>
                </div>
            </div>

            {/* Sign Up Modal */}
            <div className="modal" id="signupModal">
                <div className="modal-content">
                    <span className="modal-close" onClick={hideSignUpModal}>✖</span>
                    <h3>Sign Up</h3>
                    <form id="signupForm" onSubmit={handleSignUp}>
                        <input type="text" placeholder="Name" required />
                        <select required>
                            <option value="">Select Role</option>
                            <option value="teacher">Teacher</option>
                            <option value="parent">Parent</option>
                            <option value="student">Student</option>
                        </select>
                        <input type="email" placeholder="Email" required />
                        <input type="tel" placeholder="Phone" required />
                        <input type="password" placeholder="Password" required />
                        <input type="password" placeholder="Confirm Password" required />
                        <button type="submit">Sign Up</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default HomePage;
